import Vue from 'vue'
import Chat from './Chat'
import Counter from './Counter'
import LineChart from './LineChart'
import PieChart from './PieChart.vue'
import BarChart from './BarChart.vue'
import TargetChart from './TargetChart.vue'
import TargetBar from './TargetBar.vue'
import PieChartChannels from './PieChartChannels.vue'
import PieChartChannelsCost from './PieChartChannelsCost.vue'
import PieChartChannelsSales from './PieChartChannelsSales.vue'
import PieChartChannelsArrangementFee from './PieChartChannelsArrangementFee.vue'
import BarChartContractual from './BarChartContractual.vue'
import BarChartAgency from './BarChartAgency.vue'
import MultiDoughnutChart from './MultiDoughnutChart.vue'
import HtmlPresenter from './HtmlPresenter.vue'

export default Vue.component('widget-renderer', {
    components: {
        Chat,
        Counter,
        LineChart,
        PieChart,
        BarChart,
        TargetChart,
        TargetBar,
        PieChartChannels,
        PieChartChannelsCost,
        PieChartChannelsSales,
        PieChartChannelsArrangementFee,
        BarChartContractual,
        BarChartAgency,
        MultiDoughnutChart,
        HtmlPresenter
    },
    render: function (createElement) {
      return createElement(
        this.widget.type,
        {
            props: {
                widget: this.widget
            }    
        }
        // [
        //   createElement('a', {
        //     attrs: {
        //       name: headingId,
        //       href: '#' + headingId
        //     }
        //   }, this.$slots.default)
        // ]
      )
    },
    props: {
      widget: {
        type: Object,
        required: true
      }
    }
  })